import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import createCssVarRevertPlugin from 'css-vars-revert';

const lagacyStyleAwareCache = createCache({
  key: 'legacy-css',
  stylisPlugins: [
    createCssVarRevertPlugin({
      applyWhen: () => !window.CSS || !CSS.supports('color', 'var(--fake-var)'),
    }),
  ],
});

export const LegacyStyleProvider: React.FC = ({ children }) => {
  return <CacheProvider value={lagacyStyleAwareCache} children={children} />;
};
